import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MessageCircleMore } from "lucide-react";

// Big "Get expert help on WhatsApp" CTA. Hidden until an owner sets a WhatsApp number in Admin → Settings.
export function WhatsAppExpertCTA({ assignmentTitle }) {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    api.get("/config").then(({ data }) => setCfg(data)).catch(() => setCfg({ whatsapp_number: "" }));
  }, []);

  if (!cfg || !cfg.whatsapp_number) return null;

  const base = cfg.whatsapp_message || "Hi ThinkInk — I'd like expert help with my assignment.";
  const msg = assignmentTitle ? `${base} (Assignment: ${assignmentTitle})` : base;
  const href = `https://wa.me/${cfg.whatsapp_number}?text=${encodeURIComponent(msg)}`;

  return (
    <a href={href} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-expert-cta"
      className="group flex items-center justify-between gap-4 rounded-2xl border border-[#25D366]/40 bg-gradient-to-r from-[#0B5D3B] to-[#0C4A4A] p-5 text-white shadow-[0_10px_30px_rgba(11,93,59,0.25)] transition-transform duration-200 hover:-translate-y-0.5">
      <div className="flex items-center gap-4">
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#25D366] text-[#07351f]">
          <MessageCircleMore className="h-6 w-6" strokeWidth={2.4} />
        </span>
        <div>
          <div className="font-display text-lg font-bold">Need a human expert?</div>
          <div className="text-sm text-white/80">Chat with a ThinkInk specialist on WhatsApp about this assignment.</div>
        </div>
      </div>
      <span className="hidden shrink-0 rounded-full bg-[#25D366] px-5 py-2.5 font-semibold text-[#07351f] transition-colors group-hover:bg-[#1fc15c] sm:inline-block">
        Message on WhatsApp
      </span>
    </a>
  );
}
